module.exports = "./img/3b799cb147ccbdd2927d584e3b6ccf81.png";